<template>
  <div class="dod-container add-worker-wrapper">
    <div class="header-wrapper">
      <dod-view-title
        :title="
          customerQuery
            ? 'Edycja podopiecznego'
            : employeeQuery
            ? 'Edycja opiekuna'
            : 'Dodawanie nowej osoby'
        "
        class="bolded"
      />
      <img
        v-if="customerQuery || employeeQuery"
        class="exit-btn"
        @click="exitForm"
        src="../../icons/dod/dodExitBtn.svg"
        alt="Exit"
      />
    </div>
    <DodBorderSection class="flex">
      <template v-slot:section-slot>
        <div class="flex">
          <div
            v-if="!customerQuery && !employeeQuery"
            class="input-radio-wrapper"
          >
            <input
              type="radio"
              value="Customer"
              id="Customer"
              v-model="pickedFormType"
            />
            <label for="Customer" style="width: 100%; cursor: pointer"
              >Podopieczny</label
            >
          </div>
          <div
            v-if="!customerQuery && !employeeQuery"
            class="input-radio-wrapper"
          >
            <input
              type="radio"
              value="Employee"
              id="Employee"
              v-model="pickedFormType"
            />
            <label for="Employee" style="width: 100%; cursor: pointer"
              >Opiekun</label
            >
          </div>
        </div>
        <custom-select
          v-if="
            pickedFormType === 'Customer' &&
            departments &&
            departments.length > 0
          "
          :options="departments"
          :prePick="department"
          :default-value="'Wydział'"
          :special-char="'*'"
          style="margin-left: auto"
          :errorMsg="isError && !department ? 'Podaj wydział' : ''"
          @newPick="(e) => (department = e)"
        />
      </template>
    </DodBorderSection>
    <DodAddCustomerForm
      v-if="pickedFormType === 'Customer'"
      :pickedDepartment="department"
      :customer="customerQuery"
      @departmentAction="(e) => (isError = e)"
    />
    <DodAddEmployeeForm
      v-else-if="pickedFormType === 'Employee'"
      :employee="employeeQuery"
    />
  </div>
</template>

<script>
import CustomSelect from "../../components/CustomSelect.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import DodBorderSection from "../../components/dod/DodBorderSection.vue";
import DodAddCustomerForm from "../../components/dod/DodAddCustomerForm.vue";
import DodAddEmployeeForm from "../../components/dod/DodAddEmployeeForm.vue";
export default {
  components: {
    CustomSelect,
    DodViewTitle,
    DodBorderSection,
    DodAddCustomerForm,
    DodAddEmployeeForm,
  },
  mounted() {
    this.$store.dispatch("getDodDepartments");
    this.$store.dispatch("getDodScopesOfCare");
  },
  data() {
    return {
      pickedFormType: "Customer",
      department: "",
      customerQuery: "",
      employeeQuery: "",
      isError: "",
    };
  },
  methods: {
    exitForm() {
      if (this.$route.query.customer) {
        const parsedQuery = JSON.parse(this.$route.query.customer);
        if (parsedQuery && parsedQuery.id) {
          this.$router.push({
            name: "DodCustomerDetails",
            params: { id: parsedQuery.id },
          });
        }
      } else if (this.$route.query.employee) {
        const parsedQuery = JSON.parse(this.$route.query.employee);
        if (parsedQuery && parsedQuery.id) {
          this.$router.push({
            name: "DodEmployeeDetails",
            params: { id: parsedQuery.id },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.customer) {
      const parsedQuery = JSON.parse(this.$route.query.customer);
      this.department = parsedQuery?.department?.id;
      this.customerQuery = parsedQuery;
    } else if (this.$route.query.employee) {
      const parsedQuery = JSON.parse(this.$route.query.employee);
      this.employeeQuery = parsedQuery;
      this.pickedFormType = "Employee";
    }
  },
  computed: {
    departments() {
      const departments = this.$store.getters.getDodDepartments;
      if (departments && departments.data) {
        return departments.data.map((d) => {
          return {
            name: d.name,
            value: d.id,
            shortName: d.name,
          };
        });
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.add-worker-wrapper {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
  padding: 10px 20px !important;
  min-width: 1024px;
}
.header-wrapper {
  display: flex;
  justify-content: space-between;
}
.header-wrapper .bolded {
  font-weight: 600;
  font-size: 24px;
  color: #090741;
  margin-bottom: 0;
}
img.exit-btn {
  cursor: pointer;
}
.flex {
  display: flex;
}

.input-radio-wrapper {
  display: flex;
  padding: 5px 15px;
  align-items: center;
  border: 1px solid #c1c1cf;
  gap: 10px;
  margin-right: 20px;
  border-radius: 4px;
  width: 250px;
}

.input-radio-wrapper label {
  color: #090741;
  font-size: 14px;
  margin-bottom: 0;
  font-weight: 500;
}
input[type="radio"] {
  accent-color: #ec1a6b;
}
</style>
